import React from 'react';
import { FaFolder, FaFileAlt, FaTrash, FaSignOutAlt, FaHeadset, FaCoins, FaTimes } from 'react-icons/fa';
import { SiOpensea } from 'react-icons/si';
import { Link, useNavigate } from 'react-router-dom';
import trustb from '../assets/trustb.svg';

function Sidebar({ isOpen, toggleSidebar }) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    // Perform any necessary sign-out logic here
    navigate('/');
  };

  return (
    <div className={`fixed inset-0 z-50 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out w-64 bg-blue-100 p-4 lg:static lg:translate-x-0`}>
      <div className="flex justify-between items-center mb-4">
      <Link to="/home">
        <img src={trustb} alt="TrustForge Logo" className="h-16 w-auto" />
        </Link>
        <FaTimes className="lg:hidden text-xl cursor-pointer" onClick={toggleSidebar} />
      </div>
      <ul>
        <li className="mx-8 my-8 mb-4 flex items-center text-[#737791] font-semibold">
          <FaCoins className="mr-2" /> <Link to="/dashboard" onClick={toggleSidebar}>Dashboard</Link>
        </li>
        <li className="mx-8 mb-4 flex items-center text-[#737791]">
          <FaFolder className="mr-2" /> <Link to="/my-folder" onClick={toggleSidebar}>My Folder</Link>
        </li>
        <li className="mx-8 mb-4 flex items-center text-[#737791]">
          <FaFileAlt className="mr-2" /> <Link to="/my-documents" onClick={toggleSidebar}>My Documents</Link>
        </li>
        <li className="mx-8 mb-4 flex items-center text-[#737791]">
          <FaTrash className="mr-2" /> <Link to="/bin" onClick={toggleSidebar}>Bin</Link>
        </li>
        <li className="mx-8 mb-4 flex items-center text-[#737791]">
          <SiOpensea className="mr-2" /> <Link to="/nft" onClick={toggleSidebar}>NFT</Link>
        </li>
        <li className="mx-8 mb-4 flex items-center text-[#737791]">
          <FaHeadset className="mr-2" /> <Link to="/support" onClick={toggleSidebar}>Support</Link>
        </li>
      </ul>
      <div className="mx-8 mb-4 flex items-center text-[#737791] cursor-pointer" onClick={handleSignOut}>
        <FaSignOutAlt className="mr-2" /> Sign Out
      </div>
    </div>
  );
}

export default Sidebar;
